import { Injector, NgModule } from '@angular/core';
import { MenuService } from '../../menu/services/menu.service';
import { PluginService } from '../../plugins/services/plugin.service';

@NgModule({
    imports: [],
    exports: []
})
export abstract class BootstrapModule {

    constructor(protected injector: Injector, protected menuService: MenuService, protected pluginService: PluginService) {
        if (this[ 'boot' ] && typeof this[ 'boot' ] === 'function') {
            this[ 'boot' ](this.injector);
        }

        if (this[ 'menus' ] && typeof this[ 'menus' ] === 'function') {
            this[ 'menus' ](this.menuService);
        }

        if (this[ 'plugins' ] && typeof this[ 'plugins' ] === 'function') {
            this[ 'plugins' ](this.pluginService);
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/modules/bootstrap-module.ts